/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ app: NonNullable<unknown> }} Platform_Contact_Client_BodyInputs */

const en_platform_contact_client_body = /** @type {(inputs: Platform_Contact_Client_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.app} is the software they use, not the studio itself. Sign in and you will find their page, their times and your plan.`)
};

const pl_platform_contact_client_body = /** @type {(inputs: Platform_Contact_Client_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.app} to oprogramowanie, z którego korzysta, a nie samo studio. Zaloguj się, a znajdziesz jego stronę, terminy i swój plan.`)
};

/**
* | output |
* | --- |
* | "{app} is the software they use, not the studio itself. Sign in and you will find their page, their times and your plan." |
*
* @param {Platform_Contact_Client_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_contact_client_body = /** @type {((inputs: Platform_Contact_Client_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Contact_Client_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_contact_client_body(inputs)
	return en_platform_contact_client_body(inputs)
});